import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { RuntimeSchemaSpecific, SchemaNullSpecific } from '../../types'

export class SchemaNullDefinition extends SchemaDefinition {
  override defaultsMerge(value: any) {
    return value
  }

  override getIn(schema: SchemaNullSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaNullSpecific) {
    return schema
  }

  override inferOnlySchema(schema: SchemaNullSpecific) {
    return schema
  }

  override inferTypeScript(): string {
    return `null`
  }

  override prune(target: any): any {
    return target
  }

  override transform() {
    return null
  }

  override validate(target: any, schema: any): void
  override validate(
    target: any,
    schema: RuntimeSchemaSpecific<SchemaNullSpecific>
  ): void {
    this.validateMetadata(target, schema, (target) => target === null)
  }
}
